import { store } from 'react-notifications-component';

const DEFAULT_ERROR_MESSAGE = 'Falha ao processar a solicitacao. Tente novamente mais tarde.';
let lastNotification = { key: '', timestamp: 0 };

const formatErrorValue = (value) => {
  if (!value) return '';

  if (typeof value === 'string') return value;

  if (Array.isArray(value)) {
    return value.map(formatErrorValue).filter(Boolean).join('\n');
  }

  if (typeof value === 'object') {
    return Object.values(value).map(formatErrorValue).filter(Boolean).join('\n');
  }

  return String(value);
};

export const getApiErrorMessage = (error, fallback = DEFAULT_ERROR_MESSAGE) => {
  const data = error?.response?.data;
  const errorsMessage = formatErrorValue(data?.errors);
  const detailMessage = formatErrorValue(data?.message || data?.mensagem);

  if (errorsMessage && detailMessage && errorsMessage !== detailMessage) {
    return `${errorsMessage}\n${detailMessage}`;
  }

  const message = formatErrorValue(
    errorsMessage ||
    detailMessage ||
    data?.mensagem ||
    data?.error ||
    data?.erro ||
    data?.data?.errors ||
    data?.data?.message ||
    data
  );

  return message || fallback;
};

export const notifyApiError = (error, fallback = DEFAULT_ERROR_MESSAGE) => {
  const message = getApiErrorMessage(error, fallback);
  const key = `Erro!|${message}`;
  const now = Date.now();

  if (lastNotification.key === key && now - lastNotification.timestamp < 1500) {
    return;
  }

  lastNotification = { key, timestamp: now };

  store.addNotification({
    title: 'Erro!',
    message,
    type: 'danger',
    insert: 'top',
    container: 'top-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 4000,
      onScreen: true
    }
  });
};
